import request from '@/api/req/request'

/** 获取任务列表*/
export function getMyTasks(page, status) {
  return request.get('/index/task/getMyTasks', {
    params: {
      page,
      status
    }
  })
}



/** 获取发布任务列表*/
export function getMyPublisTasks(page) {
  return request.get('/index/task/getMyPublishedTasks', {
    params: {
      page
    }
  })
}

/** 我的发布--v2*/
export function getMyPublishedTasksApi(page) {
  return request({
    url: '/index/V2.task/getMyPublishedTasks',
    method: 'post',
    data: {
      page
    }
  })
}
/** 我的领取---v2*/
export function getMyTasksApi(status, page) {
  return request({
    url: '/index/V2.task/getMyTasks',
    method: 'post',
    data: {
      page,
      status,
    }
  })
}
/** 我的任务统计 ---v2 */
export function countTaskApi() {
  return request({
    url: '/index/V2.task/countTask',
    method: 'post'
  })
}

/** 标签列表 ---v2 */
export function getTaskTagApi() {
  return request({
    url: '/index/V2.task/getTaskTag',
    method: 'post' 
  })
}

/**获取任务大厅*/
export function getAllTask(page) {
  return request.get('/index/task/getNotTakeTasks', {
    params: {
      page
    }
  })
}
/** 获取任务大厅列表v2*/
export function getNotTakeTasksApi(data) {
  return request({
    url: '/index/V2.task/getNotTakeTasks',
    method: 'POST',
    data
  })
}


/**获取已领任务*/
export function getOldTask(page) {
  return request.get('/index/task/getTookList', {
    params: {
      page
    }
  })
}

/**查询任务*/
export function getIdTask(task_id, uid) {
  return request.get('/index/task/getTaskInfo', {
    params: {
      task_id: task_id,
      with_stage: 1,
      with_file: 1,
      uid
    }
  })
}

/**查询任务*/
export function getIdTaskApi(task_id, uid) {
  return request.get('/index/V2.task/getTaskInfo', {
    params: {
      task_id: task_id,
      with_stage: 1,
      with_file: 1,
      uid
    }
  })
}

/**抢任务*/
export function getInTask(task_id, uid) {
  return request.get('/index/task/takeTask', {
    params: {
      task_id,
      uid
    }
  })
}

/**提交任务验收*/
export function askCheck(s) {
  return request.get('/index/task/askCheck', {
    params: {
      ...s
    }
  })
}

/***/
export function getDayType(task_id) {
  return request.get('/index/task/getTaskLog', {
    params: {
      task_id: task_id
    }
  })
}

/**反馈任务问题*/
export function askTaskQuestion(task_id, content, file_ids) {
  return request.post('/index/task/askTaskQuestion', {
    task_id,
    content,
    file_ids
  })
}


/**评价任务*/
export function evaluateTask(as) {
  return request.post('/index/task/addTaskScore', as)
}

/**反馈任务图片*/
export function upQuestionImg(images) {
  return request.post('/index/files/uploandImg',
    images
  )
}

/*获取反馈列表**/
export function getTaskQuestions(task_id, page) {
  return request.get('/index/task/getTaskQuestions', {
    params: {
      task_id,
      page
    }
  })
}


/*获取任务评分**/
export function getTaskEav(task_id) {
  return request.get('/index/task/getTaskScore', {
    params: {
      task_id
    }
  })
}